import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100/80 border-t border-primary-800/60">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-primary-950 text-lg">
                <i className="ri-movie-2-fill"></i>
              </span>
              <span className="font-heading font-bold text-background-50 text-lg">
                {siteInfo.brandFull}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-100/70">
              {siteInfo.intro}
            </p>
            <p className="mt-4 text-xs text-background-100/50">
              本站为影视作品专题内容展示站，所有剧情与资讯均为虚构演示内容。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-medium mb-4 text-sm">
              <Link to="/" className="cursor-pointer hover:text-accent-400 transition-colors">
                站内导航
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-medium mb-4 text-sm">
              <Link to="/about" className="cursor-pointer hover:text-accent-400 transition-colors">
                联系与声明
              </Link>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <a
                  href={`mailto:${siteInfo.contactEmail}`}
                  className="hover:text-accent-400 transition-colors cursor-pointer break-all"
                >
                  {siteInfo.contactEmail}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400"></i>
                <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
                  隐私声明
                </Link>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-information-line text-accent-400"></i>
                <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
                  免责声明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/50">
          <p>© {siteInfo.year} {siteInfo.brandFull}. 保留所有权利。</p>
          <p className="text-center sm:text-right">
            内容仅供影迷交流使用 · 不含播放、下载与付费功能
          </p>
        </div>
      </div>
    </footer>
  );
}